import React, { useCallback } from 'react';
import './sign-submit-token-redeem.scss';
import Step from 'modules/step';
import {TokenRedemptionDocumentType, TokenRedemptionType} from 'constants/redemption';
import TokenRedemptionParams from '../TokenRedemptionParams';
import { getFormatedDate } from 'utils';
import { LoadDocBtn } from '@ru-digital-assets/ui-component';
import { useSelector, useDispatch } from 'hooks/redux';
import { downloadFile } from 'utils/files/downloadFile';
import { setPush } from 'store/actions/app';
import RedemptionApi from 'services/api/RedemptionApi';
import { useHistory } from 'react-router';
import { showLoader, hideLoader } from 'store/actions/loader';
import { BlockchainTransactionInfo } from 'components';

interface ISignSubmitTokenRedeem {
  redemptionType: TokenRedemptionType;
  asset: any;
}

export default function SignSubmitTokenRedeem({
  redemptionType,
  asset,
}: ISignSubmitTokenRedeem) {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = useSelector((state) => state.auth.account.token);
  const assetId = history.location.state.id;

  const downloadDoc = useCallback((name: string, mimeType: string) => {
    dispatch(showLoader());
    RedemptionApi.getRedeemPaymentDocument(token, assetId)
      .then((response) => {
        downloadFile(response.data, name, mimeType);
      })
      .catch(() => {
        dispatch(
          setPush({
            message: 'Ошибка при загрузке документа',
            type: 'error',
          })
        );
      })
      .finally(() => {
        dispatch(hideLoader());
      });
  }, []);

  const downloadNotifyDoc = useCallback((name: string, mimeType: string, isSignature: boolean) => {
    dispatch(showLoader());
    RedemptionApi.getRedeemDocument(token, assetId, isSignature ?
        TokenRedemptionDocumentType.NOTIFY_REDEEM_DOC_SIG :
        TokenRedemptionDocumentType.NOTIFY_REDEEM_DOC)
        .then((response) => {
          downloadFile(response.data, name, mimeType);
        })
        .catch(() => {
          dispatch(
              setPush({
                message: 'Ошибка при загрузке документа',
                type: 'error',
              })
          );
        })
        .finally(() => {
          dispatch(hideLoader());
        });
  }, []);

  const downloadAgreementDoc = useCallback((name: string, mimeType: string, isSignature: boolean) => {
    dispatch(showLoader());
    RedemptionApi.getRedeemDocument(token, assetId, isSignature ?
        TokenRedemptionDocumentType.AGREEMENT_DOC_SIG :
        TokenRedemptionDocumentType.AGREEMENT_DOC)
        .then((response) => {
          downloadFile(response.data, name, mimeType);
        })
        .catch(() => {
          dispatch(
              setPush({
                message: 'Ошибка при загрузке документа',
                type: 'error',
              })
          );
        })
        .finally(() => {
          dispatch(hideLoader());
        });
  }, []);

  return (
    <div className="sign-submit-token-redeem">
      <div className="sign-submit-token-redeem__left">
        <div className="mb_32">
          <Step
            steps={[
              { title: 'Инициация погашения' },
              { title: 'Оплата' },
              { title: 'Подтверждение погашения', active: true },
            ]}
          />
        </div>
        <p className="p p_font-size_24 p_font-weight_light mb_8">
          Погашение {asset.actualCount} токенов{' '}
          {asset.issuingInfo.tokenName}
        </p>
        <div className="sign-submit-token-redeem__alert-badge mb_32">
          <p className="p p_font-size_12">Требуется подтвердить погашение</p>
        </div>
        <p className="p p_bold mb_24">Документы для погашения:</p>
        <div className="mb_16">
          <LoadDocBtn
            title="Документ подтверждающий факт оплаты"
            extension=".PDF"
            onSpecDownload={() =>
              downloadDoc(
                'Документ подтверждающий факт оплаты',
                'application/pdf'
              )
            }
          />
        </div>
        <div className="mb_16">
          <LoadDocBtn
              title={`Уведомление об исполнении обязательств`}
              extension=".PDF"
              onSpecDownload={() =>
                  downloadNotifyDoc('Уведомление об исполнении обязательств',
                      'application/pdf',
                      false
                  )
              }
              sig={['REDEEMED', 'REDEEM_PAYMENT_SIGNED', 'OWNER_PAYMENT_SIGNED'].includes(asset.status)}
              onSpecDownloadSig={() => {
                downloadNotifyDoc('Уведомление об исполнении обязательств.pdf.sig',
                    'application/pdf',
                    true
                )
              }}
          />
        </div>
          {['REDEEMED', 'REDEEM_PAYMENT_SIGNED', 'OWNER_PAYMENT_SIGNED'].includes(asset.status) && (
              <div className="mb_16">
                  <LoadDocBtn
                      title={`Заявление о надлежащем исполнении`}
                      extension=".PDF"
                      onSpecDownload={() =>
                          downloadAgreementDoc('Заявление о надлежащем исполнении',
                              'application/pdf',
                              false
                          )
                      }
                      sig={['REDEEMED', 'OWNER_PAYMENT_SIGNED'].includes(asset.status)}
                      onSpecDownloadSig={() => {
                          downloadAgreementDoc('Заявление о надлежащем исполнении.pdf.sig',
                              'application/pdf',
                              true
                          )
                      }}
                  />
              </div>
          )}
        {/*<LoadDocBtn*/}
        {/*  title={*/}
        {/*    redemptionType === TokenRedemptionType.execution*/}
        {/*      ? 'Заявление о надлежащем исполнении обязательств Эмитентом'*/}
        {/*      : 'Заявление о признании обязательств Эмитента прекратившимися'*/}
        {/*  }*/}
        {/*  extension=".PDF"*/}
        {/*  onSpecDownload={() =>*/}
        {/*    downloadDoc(*/}
        {/*      redemptionType === TokenRedemptionType.execution*/}
        {/*        ? 'Заявление о надлежащем исполнении обязательств Эмитентом'*/}
        {/*        : 'Заявление о признании обязательств Эмитента прекратившимися',*/}
        {/*      'application/pdf'*/}
        {/*    )*/}
        {/*  }*/}
        {/*/>*/}
      </div>
      <div className="sign-submit-token-redeem__right">
        <p className="p p_bold mb_24">Параметры погашения</p>
        <p className="p p_font-size_12 p_color_light-grey">ID транзакции</p>
        <div className="mb_32">
          <BlockchainTransactionInfo hash={asset.blockchainTransactionId} />
        </div>
        <TokenRedemptionParams redemptionType={redemptionType} asset={asset} />
        <p className="p p_font-size_12 p_color_light-grey mt_12">
          Дата исполнения обязательств:
        </p>
        <p className="p p_font-size_18">
          {getFormatedDate(asset.issuingInfo.finalizedDate, 'dd.MM.yyyy')}
        </p>
      </div>
    </div>
  );
}
